import * as React from "react";
import cx from "classnames";
import { kebabCaseToCamelCase } from "../helpers";
import { IWithStylesProps, UTILITY_CLASSES } from "./utility-classes";

const utilityClassesInCamelCase = UTILITY_CLASSES.map(kebabCaseToCamelCase);

const sanitizeStyleProps = <P extends object>(
  props: any
): [string[], Partial<P>] => {
  const classNames: string[] = [];

  utilityClassesInCamelCase.forEach((styleAttr, index) => {
    if (props[styleAttr]) {
      classNames.push("asp-utility--" + UTILITY_CLASSES[index]);
      delete props[styleAttr];
    }
  });

  return [classNames, props];
};

export const withStyles = <P extends object = IWithStylesProps>(
  Component: React.ComponentType<P>
): React.FunctionComponent<P & IWithStylesProps> => {
  const displayName = Component.displayName || Component.name || "Component";

  const ComposedComponent = ({ className, ...others }: any) => {
    const [styleClasses, propWithoutStyles] = sanitizeStyleProps(others);

    const _classNames = cx(styleClasses, className);

    return <Component {...(propWithoutStyles as P)} className={_classNames} />;
  };

  ComposedComponent.displayName = `withStyles(${displayName})`;

  return ComposedComponent as React.FunctionComponent<P & IWithStylesProps>;
};
